var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex rounded-lg bg-primary-50 p-1 h-11 w-full"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,class:[
      'flex-1 text-center cursor-pointer box-border py-2 text-sm text-secondary-100 rounded-lg font-normal transition-all duration-200 focus:outline-none',
      (_vm.selectedValue || _vm.defaultValue) === option.value
        ? 'bg-base-0 text-gray-900 shadow-sm font-bold'
        : ''
    ],attrs:{"aria-pressed":(_vm.selectedValue || _vm.defaultValue) === option.value},on:{"click":function($event){return _vm.$emit('option-click', option.value)}}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }